import { PlainInput2 } from 'components/PlainInput/PlainInput2'

import type { GeneratedSignedPdfConfigItem } from './constants'

interface Props {
  staticValues: Record<string, any>
  config: Record<string, GeneratedSignedPdfConfigItem>
  isLoading: boolean
  onChange: (key: string, data: Record<string, any>) => void
}

export const GeneratedSignedPdf = ({ staticValues, config, isLoading, onChange }: Props) => {
  const entries = Object.entries(staticValues)

  if (!isLoading && entries.length === 0) {
    return <p className="text-gray-500 p-4">No configuration items found.</p>
  }

  return (
    <div className="px-3 py-2">
      <div className="text-xl font-bold mb-4">Generated Signed PDF</div>

      <table className="w-full text-sm">
        <thead>
          <tr className="bg-gray-100">
            <th className="p-2 text-left">#</th>
            <th className="p-2 text-left">Title</th>
            <th className="p-2 text-left">Condition No</th>
          </tr>
        </thead>
        <tbody>
          {entries.map(([key, value], index) => (
            <tr key={key} className={index % 2 ? 'bg-slate-50' : ''}>
              <td className="p-2">{index + 1}</td>
              <td className="p-2">{value}</td>
              <td className="p-2 w-40">
                <PlainInput2
                  value={String(config[key]?.conditionNo ?? '')}
                  content={String(config[key]?.conditionNo ?? '-')}
                  type="number"
                  onChange={(val: string) => onChange(key, { conditionNo: Number(val) })}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
